export default "__VITE_ASSET__C3nrZQDl__"